import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { ChatAppMessageProperties } from '../Models/ChatAppProperties';
import { ResponseToClient } from '../Models/OfflineNewProperties';
import { OfflineNewVersionProperties, OfflineMessageToChatRequiredProperties, OfflineStatusNewVersion, OfflineBookingSourceProperties } from '../offline-new/offlineNewProperties';

@Injectable({
  providedIn: 'root'
})
export class OfflineNewVersionService {
  baseUrl = environment.baseUrl;
  backSystemUrl = environment.backSystemBaseUrl;
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json'
    })
  }
  constructor(private http: HttpClient) { }
  CreateOfflineRequest(Obj): Observable<ResponseToClient> {
    return this.http.post<ResponseToClient>(this.baseUrl + '/OfflineNewVersion/CreateOfflineRequest', Obj, this.httpOptions)
      .pipe(map((data: any) => {
        return data;
      }), catchError(error => { return throwError(error); }))
  }
  OtherRequestCreateUpdate(Obj): Observable<ResponseToClient> {
    return this.http.post<ResponseToClient>(this.baseUrl + '/OfflineNewVersion/OtherRequestCreateUpdate', Obj, this.httpOptions)
      .pipe(map((data: any) => {
        return data;
      }), catchError(error => { return throwError(error); }))
  }
  UpdateOfflineRequest(Obj): Observable<ResponseToClient> {
    return this.http.post<ResponseToClient>(this.baseUrl + '/OfflineNewVersion/UpdateOfflineRequest', Obj, this.httpOptions)
      .pipe(map((data: any) => {
        return data;
      }), catchError(error => { return throwError(error); }))
  }
  InProgressTag(Obj): Observable<ResponseToClient> {
    return this.http.post<ResponseToClient>(this.baseUrl + '/OfflineNewVersion/InProgressTag', Obj, this.httpOptions)
      .pipe(map((data: any) => {
        return data;
      }), catchError(error => { return throwError(error); }))
  }
  GetOfflineBookingById(uniqueId): Observable<OfflineNewVersionProperties> {
    return this.http.get<OfflineNewVersionProperties>(this.baseUrl + '/OfflineNewVersion/GetOfflineBookingById/' + uniqueId)
      .pipe(map((data: any) => {
        return data;
      }), catchError(error => { return throwError(error); }))
  }
  GetOfflineBookingByIdByCriteria(uniqueId, userid): Observable<OfflineNewVersionProperties> {
    return this.http.get<OfflineNewVersionProperties>(this.baseUrl + '/OfflineNewVersion/GetOfflineBookingByIdByCriteria/' + uniqueId + '/' + userid)
      .pipe(map((data: any) => {
        return data;
      }), catchError(error => { return throwError(error); }))
  }
  GetNotificationList(uniqueId): Observable<ChatAppMessageProperties[]> {
    return this.http.get<ChatAppMessageProperties[]>(this.baseUrl + '/OfflineNewVersion/GetNotificationList/' + uniqueId)
      .pipe(map((data: any) => {
        return data;
      }), catchError(error => { return throwError(error); }))
  }
  ChecktheManagerOrNot(Obj): Observable<OfflineMessageToChatRequiredProperties> {
    return this.http.post<OfflineMessageToChatRequiredProperties>(this.baseUrl + '/OfflineNewVersion/ChecktheManagerOrNot', Obj, this.httpOptions)
      .pipe(map((data: any) => {
        return data;
      }), catchError(error => { return throwError(error); }))
  }
  OfflineBackOfficeReportGetbyCriteria(obj): Observable<OfflineNewVersionProperties[]> {
    return this.http.post<OfflineNewVersionProperties[]>(this.baseUrl + '/OfflineNewVersion/OfflineBackOfficeReportGetbyCriteria', obj, this.httpOptions)
      .pipe(map((data: any) => {
        return data;
      }), catchError(error => { return throwError(error); }))
  }
  GetOfflineStatus(): Observable<OfflineStatusNewVersion[]> {
    return this.http.get<OfflineStatusNewVersion[]>(this.baseUrl + '/OfflineNewVersion/GetOfflineStatus' )
      .pipe(map((data: any) => {
        return data;
      }), catchError(error => { return throwError(error); }))
  }

  GetOfflineBookingSource(): Observable<OfflineBookingSourceProperties[]> {
    return this.http.get<OfflineBookingSourceProperties[]>(this.baseUrl + '/OfflineNewVersion/GetOfflineBookingSource')
      .pipe(map((data: any) => {
        return data;
      }), catchError(error => { return throwError(error); }))
  }
}
